import React from 'react'
import PropTypes from 'prop-types'

import { parseCredit } from '../../utils'
import LineItem from '../../LineItem'

const OnlineOrderCredit = ({ dataTestId, hide, lang, recurringCredit, translations }) => {
  const onlineOrderCreditCost = parseCredit(recurringCredit)
  const hasOnlineOrderCredit = onlineOrderCreditCost !== 0
  if (hide || !hasOnlineOrderCredit) return null
  return (
    <LineItem
      text={translations.oneTimeWebCredit}
      cost={onlineOrderCreditCost}
      lang={lang}
      annotationInline
      dataIdAttribute={`${dataTestId}-price-summary-hs-web-credit`}
    />
  )
}

OnlineOrderCredit.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  recurringCredit: PropTypes.number.isRequired,
  translations: PropTypes.object.isRequired,
  hide: PropTypes.bool
}

OnlineOrderCredit.defaultProps = {
  hide: false
}

export default OnlineOrderCredit
